import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const SupportButtonHeader = () => {
    const { t } = useTranslation();
    return (
      
     
         <div className="support-buttons">


    <Link to="/documentation?type=agency" className="support-btn documentation-btn">
      <div className="btn-icon">
        <i className="fe fe-book-open"></i>
      </div>
      <span className="btn-text">{t("Documentation Agency")}</span>
    </Link>
    <Link to="/documentation?type=vendor" className="support-btn documentation-btn">
      <div className="btn-icon">
        <i className="fe fe-book-open"></i>
      </div>
      <span className="btn-text">{t("Documentation Vendor")}</span>
    </Link>

        <Link to="/feedback" className="support-btn feedback-btn">
      <div className="btn-icon">
        <i className="fe fe-message-circle"></i>
      </div>
      <span className="btn-text">{t("Feedback")}</span>
    </Link>
    
  </div>

    );
}
export default SupportButtonHeader;